<template>
    <div class="row py-5">
        <div class="col-12 px-3 px-lg-5">
            <div v-if="Object.keys(warehouse).length !== 0" class="row align-items-center mb-4">
                <div class="col-12">
                    <h2 class="mb-0">{{ $t("orders.warehouse") }} - {{ warehouse.name }}</h2>
                    <span class="text-muted">{{ warehouse.address.full_address }}</span>
                </div>
            </div>

            <div class="row">
                <div v-if="canEdit" class="col-12">
                    <WarehouseQuickEntry ref="quickEntry" :warehouseId="warehouseId" :stock="stockList"
                        :conversions="conversions" @updated="loadData" />
                </div>

                <div class="col-12">
                    <h3 class="h5 mb-1">{{ $t("warehouses.stock") }}</h3>
                    <p v-if="canEdit" class="text-muted small">{{ $t("warehouses.stockHelp") }}</p>
                </div>
                <div class="col-12 col-xl-8">
                    <LoadingSpinner :loading="loading" />
                    <div>
                        <div v-for="item in stockList" :key="item.id" class="row py-1 pt-2 align-items-center item"
                            :class="{ 'stock-row': canEdit }" @click="canEdit && $refs.quickEntry.selectProduct(item.product.id)">
                            <div class="col-8">
                                <b class="me-2">{{ item.product.shorten_name }}</b>
                                <span class="text-muted small">{{ item.product.name }}</span>
                            </div>
                            <div class="col-4 text-end text-nowrap">
                                <b :class="amountClass(item.amount)">{{ formatAmount(item.amount) }}</b>
                                {{ item.product.measurement_unit }}
                            </div>
                        </div>
                    </div>
                </div>

                <WarehouseStockChanges ref="changes" :warehouseId="warehouseId" :products="products"
                    @changed="loadData" />
            </div>
        </div>
    </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import WarehouseStockChanges from "../components/WarehouseStockChanges.vue";
import WarehouseQuickEntry from "../components/WarehouseQuickEntry.vue";

export default {
    components: {
        LoadingSpinner,
        WarehouseStockChanges,
        WarehouseQuickEntry
    },
    data() {
        return {
            warehouseId: null,
            warehouse: {},
            stockList: [],
            conversions: [],
            loading: true
        }
    },
    created() {
        this.warehouseId = this.$route.params.id;
        this.$store.getters.api.get("/warehouse/" + this.warehouseId).then((response) => {
            this.warehouse = response.data.item;
        });
        if (this.canEdit && this.$store.getters.hasPerm("view_productconversion")) {
            this.$store.getters.api.get("/product_conversions", {
                params: { per_page: 1000 }
            }).then((response) => {
                this.conversions = response.data.items;
            });
        }
        this.loadData();
    },
    computed: {
        canEdit() {
            return this.$store.getters.hasPerm("change_warehouse");
        },
        products() {
            return this.stockList.map((item) => item.product);
        }
    },
    methods: {
        loadData: function () {
            this.$store.getters.api.get("/warehouse/" + this.warehouseId + "/product_stock", {
                params: { per_page: 1000 }
            }).then((response) => {
                this.stockList = response.data.items;
                this.loading = false;
            });
            if (this.$refs.changes) {
                this.$refs.changes.reload();
            }
        },
        amountClass(amount) {
            if (amount < 0) return "text-danger";
            if (amount === 0) return "text-muted";
            return "";
        }
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";

.stock-row {
    cursor: pointer;

    &:hover {
        background-color: $grey;
    }
}
</style>
